import { createCtx } from './contextFactory';

const [ctx, Provider] = createCtx({
    globals: null
});

export const GlobalsContext = ctx;

export const GlobalsProvider = Provider;
